var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudioDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    className: "iconBlue",
    d: "M44 18v24a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v4a2 2 0 1 0 4 0V6a6 6 0 0 0-6-6H6a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h36a6 6 0 0 0 6-6V18a2 2 0 1 0-4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "iconBlue",
    d: "M10 40a2 2 0 1 1 0-4h4a2 2 0 1 1 0 4h-4zm12 0a2 2 0 1 1 0-4h4a2 2 0 1 1 0 4h-4zm12 0a2 2 0 1 1 0-4h4a2 2 0 1 1 0 4h-4zM22 16H10a2 2 0 1 1 0-4h12a2 2 0 1 1 0 4zm12-8a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm0 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "iconOrange",
    d: "M26 28a2 2 0 1 1 0-4h12a2 2 0 1 1 0 4H26zm-12-8a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm0 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioDesign);
export default __webpack_public_path__ + "static/media/studioDesign.3a80e41105451f01358fb8aa3b241039.svg";
export { ForwardRef as ReactComponent };